export default __webpack_public_path__ + "static/media/stage_02@2x.eb50a547.png";